<button class="btn light-blue-border pagination-btn" (click)="onClick.emit()" [ngStyle]="{ width }" [disabled]="disabled">{{text}}</button>
